// @ts-nocheck
import React from 'react';

import { Link } from "react-router-dom";

import CustomizedDialogs from 'components/dialog';

const Footer = () => {
  return (
    <>

      <footer className=" bg-[#A91314]  text-white">
        <div className="container grid pt-10 pb-10 md:grid-cols-3">
          <div className="flex flex-col justify-between col-span-1 row-span-1">
            <div className="z-50 flex flex-col justify-between md:flex-row pt-[20px]">
              <Link to="/">
                <p className="flex items-center gap-4 text-sm md:text-base hover:text-orange">
                  <img
                    className="w-12 h-12 rounded-full"
                    src="/images/logo.png"
                    alt=""
                  />
                  <div className="leading-5">
                    <h2 className="pb-[2px] mb-[2px] border-b border-red">Салезіяни Святого Івана Боско, УГКЦ</h2>
                    <h2 className="">Salesians of Don Bosco, Ukraine</h2>
                  </div>
                </p>
              </Link>
            </div>
            <div className="flex flex-col pl-[60px] max-md:pt-[15px]">
              <span className="md:text-xl">Львів, Личаківська 175</span>
              <span className="md:text-xl ">Салезіянське Згромадження, УГКЦ.</span>
            </div>
          </div>
          <div className="flex flex-col col-span-1 row-span-1 md:border-l md:border-r max-md:border-t max-md:border-b max-md:pb-[20px] max-md:my-[20px]">
            <div className="flex justify-center pt-4 pb-6 text-xl md:px-4 md:text-xl">
              <h3 className="text-center ">Для підтримки салезіянської діяльності </h3>
            </div>
            <div className="flex justify-center">
              <CustomizedDialogs
                buttonClassName={"!border-0 !normal-case !px-4 md:!px-28 !py-1 md:!py-2 !text-black !uppercase !rounded-lg !bg-white !hover:underline !text-2xl md:!text-xl"}
                buttonText="Зробити внесок"
                modalTitle={"САЛЕЗІЯНСЬКЕ ЗГРОМАДЖЕННЯ УГКЦ"}
                modalText={
                  <div>
                    <div></div>
                    <div>ЄДРПОУ: 26360983</div>
                    <div>IBAN: UA 673253650000026005021011674</div>
                    <div>Призначення платежу: "Благодійна допомога на статутну діяльність"</div>
                    <div></div>
                  </div>
                }
              />
            </div>
            <div className="flex items-center gap-4 pt-6 max-md:pl-[50px] max-md:mb-[8px] pl-6 mt-6 border-t">
              <span className="md:text-[18px]">Офіс планування та розвитку салезіян УГКЦ</span>
            </div>
            <div className="flex items-center gap-4 pl-6 max-md:pl-[50px] ">
              <img width={28} height={28} src={"/images/email.png"} alt="текст" className="hover:opacity-80" />
              <span className="md:text-[24px]">pd_office@sdbua.net</span>
            </div>
          </div>
          <div className="flex flex-col col-span-1 row-span-1 pl-[50px] justify-between max-md:gap-2">
            <div className="flex items-center gap-4 mt-2">
              <span className="md:text-[18px]">Провінційний настоятель салезіян УГКЦ</span>
            </div>
            <div className="flex items-center gap-4 -4">
              <img width={28} height={28} src={"/images/email.png"} alt="текст" className="hover:opacity-80" />
              <span className="md:text-[24px]">superiorukr@sdbua.net</span>
            </div>



            <div className="relative flex items-center gap-8 py-4 pt-8">
              <a
                className=""

                href="https://www.instagram.com/salesiano_ukraine"
                target="_blank"
                rel="noreferrer"
              >
                <img width={37} height={37} src={"/images/instagram.png"} alt="текст" className="hover:opacity-80" />
              </a>
              <a
                className=""

                href="https://www.youtube.com/channel/UCdWDqvkHGRBh1OKQpbNfnEA"
                target="_blank"
                rel="noreferrer"
              >
                <img width={46} height={32} src={"/images/youtube.png"} alt="текст" className="hover:opacity-60" />
              </a>
              <a
                className=""
                href="https://www.facebook.com/sdbukraine"
                target="_blank"
                rel="noreferrer"
              >
                <img width={41} height={41} src={"/images/facebook.png"} alt="текст" className="hover:opacity-80" />
              </a>
              <a
                className=""

                href="https://twitter.com/sdbukr"
                target="_blank"
                rel="noreferrer"
              >
                <img width={40} height={32} src={"/images/twitter.png"} alt="текст" className="hover:opacity-80" />
              </a>


            </div>
          </div>
        </div>
        <div className="container flex ">
          <div className="flex w-full border-t justify-center items-center gap-[25px] py-[30px]">
            <span className="text-sm ">Copyright © 2025</span>
            <span className="text-sm h-[6px] w-[6px] rounded-full bg-white"></span>
            <span className="text-sm ">All rights reserved.</span>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
